<template>
    <v-app>
        <v-sheet elevation="6">
            <v-tabs
                background-color="cyan"
                dark
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
            >
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab
                    v-for="i in tabs"
                    :key="i"
                    :href="'#tab-' + i"
                >
                     {{ tabs[i] }}
                </v-tab>
            </v-tabs>
        </v-sheet>
    </v-app>
</template>

<script>

export default {
    name: "akt",
    data() {
        return {
            tabs: [
                'I. Титульная страница',
                '1. Учредительные документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
                '2. Общие документы',
            ]
        }
    },
    created() {
    },
    methods: {
        getReport() {
            document.location.href = this.$model.wwwroot+"/report/minobr/index.php/akt/print_akt?year="+this.year
        }
    }
};
</script>
